
import Tip from './Tip.vue'
const tip = {
    install: function(Vue){
        Vue.component('tip',Tip)
    }
}
export default tip


// WEBPACK FOOTER //
// ./src/components/Tip/index.js